<script>
import {useStore} from 'vuex'
import {computed, ref, onMounted} from 'vue'

export default {
    name: 'SubNavProfile',
    props: {
        smallScreenMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(){
        const store = useStore()

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "subNavigationProfile",
                labelKey: labelKey,
            });

        const userHasNotifications = computed (()=> {
            return store.state.main.user.user_has_notifications
        }) 
        const showUser = computed (()=> {
            return store.state.main.user.show_user
        }) 
        const userAuthorized = computed (()=> {
            return store.state.main.user.user_authorized
        }) 
        const userName = computed (()=> {
            return store.state.main.user.user_name
        }) 
        const userProfileImg = computed (()=> {
            return store.state.main.user.user_profile_img
        })
        const userHasLoggedInAsFrivilligAdmin = computed (() => {
            return store.state.main.user.user_has_logged_in_as_frivillig_admin
        })
        
        return {   
            userName,
            userHasNotifications,
            userProfileImg,
            showUser,
            userAuthorized,
            userHasLoggedInAsFrivilligAdmin,
            getLabel
        }
    }
}
</script>

<template>
    <template v-if="userAuthorized"> 
        <a :href="getLabel('profileLink')" class="kb-sub-navigation__login-info kb-sub-navigation__login-info-user">
            <p class="kb-sub-navigation__login-info-user-name">{{ userName }}</p>
            <span class="kb-visually-hidden">{{ getLabel('loginHelpText') }}</span>
            <figure class="kb-image-module kb-image-module--1-1 kb-group-post__contents-left-top-profile-img">
                <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                        <img :src="userProfileImg" alt="" />
                    </picture>
                </div>
                <template v-if="userHasNotifications">
                    <p class="kb-visually-hidden">{{ getLabel('notificationsHelpText') }}</p>
                    <div class="kb-sub-navigation__login-info-user-notification-dot"></div>
                </template>
                <template v-if="userHasLoggedInAsFrivilligAdmin">
                    <p class="kb-visually-hidden">{{ getLabel('loggedInAsFrivilligAdminTooltip') }}</p>
                    <div class="kb-sub-navigation__login-info-user-is-admin" :title="getLabel('loggedInAsFrivilligAdminTooltip')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                        </svg>
                    </div>
                </template>
            </figure>
        </a>
    </template>
</template>

